// Codex records change very rarely.  Cache responses for 15 minutes.
export const defaultOptions = {
  staleTime: 1000 * 60 * 15,
  cacheTime: 1000 * 60 * 20,
};
